import truncate from 'components/shared/mixins/truncate'
import { mapGetters } from 'vuex'
import routeHelper from 'components/shared/mixins/routeHelper'

export default {
    props: {
        collection: Object,
        index: {
            type: Number,
            default: null
        },
        editable: Boolean,
        isWatchListItem: {
            type: Boolean,
            default: false
        },
        isBeingEdited: {
            type: Boolean,
            default: false
        }
    },
    mixins: [ truncate, routeHelper ],
    data () {
        return {
            descLength: 380
        }
    },
    computed: {
        ...mapGetters({
            isCourseCompleted: 'CompletedCourses/isCourseCompleted',
            completedCourses: 'CompletedCourses/getCompletedCourses',
            isLoggedIn: 'isLoggedIn',
            mapCollectionToRibbon: 'CoursesCollections/mapCollectionToRibbon',
            mapCollectionToTimeBasedRibbon: 'CoursesCollections/mapCollectionToTimeBasedRibbon'
        }),
        tooltipText () {
            return this.$t('BannerCollectionInfo.please_note_bla_bla')
        },
        title () {
            return this.collection.title || 'undefined'
        },
        courses () {
            return this.collection.items.filter(item => item.type === 'course')
        },
        isCollectionCompleted () {
            return this.courses.length > 0 && this.courses.every(course => this.isCourseCompleted(course.id))
        },
        showAddToFavourite () {
            return this.isLoggedIn && !this.isWatchListItem
        },
        isFree () {
            return this.collection.flags[0] === 'free'
        },
        isPromotional () {
            return this.collection.flags[0] === 'promotional'
        },
        userHasNoAccess () {
            return this.collection.demo && this.isLoggedIn
        },
        isExpired () {
            if (this.mapCollectionToRibbon(this.collection, true)) {
                return this.mapCollectionToRibbon(this.collection, true).name === this.$t('Ribbon.unavailable')
            }
            return false
        },
        isWatchListItemInEditMode () {
            return this.isBeingEdited && this.isWatchListItem
        },
        truncateDescription () {
            if (this.collection.description.length < this.descLength) {
                return this.collection.description
            } else {
                return this.collection.description.substring(0, this.descLength) + '...'
            }
        }
    }
}
